import { PlaceNode } from '@ulysses-inc/harami_api_client'
import { localStorageKeys } from 'src/constants/localStorageKeys'

const toUuidSignature = (placeNodes: PlaceNode[]): string =>
  placeNodes
    .map(node => node.uuid)
    .sort()
    .join(',')

/**
 * 保存されていた所属現場が引数と同じかを返す。
 * 保存値が壊れていて比較できない場合は false を返し、表示条件を破棄させる。
 */
const isSameAsStoredPlaceNodes = (
  stored: string,
  nextPlaceNodes: PlaceNode[],
): boolean => {
  try {
    const parsed = JSON.parse(stored)
    if (!Array.isArray(parsed)) {
      return false
    }
    return toUuidSignature(parsed) === toUuidSignature(nextPlaceNodes)
  } catch {
    return false
  }
}

/**
 * ログインユーザーの所属現場が前回保存した内容から変わっていれば、一覧画面の絞り込み条件を
 * 破棄する。所属現場を localStorage に保存する直前に呼ぶ。
 *
 * 一覧画面の絞り込み条件は localStorage に残り、保存された現場をそのまま絞り込みに使う。
 * 所属現場が変更されると所属しなくなった現場の UUID が残るため、破棄しないと所属していない
 * 現場のデータが一覧に表示される。破棄すると各画面は絞り込み条件がない場合の表示に戻る。
 *
 * 他のユーザーが所属現場を変更した場合、所属現場の localStorage を最新化するのは AuthGuard だけで、
 * AuthGuard はアプリ全体を囲んでいるため画面遷移では再マウントされない。したがって破棄が動くのは
 * ページの再読み込み・タブを開き直したとき・再ログインのいずれかの時点になる。
 * 自分自身の所属現場を変更した場合は EditUser から呼ばれるため、その保存時点で破棄される。
 */
export const discardListFiltersOnPlaceNodesChange = (
  nextPlaceNodes: PlaceNode[],
): void => {
  const stored = localStorage.getItem(localStorageKeys.loginUserPlaceNodes)
  if (stored === null) {
    // 保存前（ログイン直後）は比較対象がない。表示条件もログアウト時に破棄済み
    return
  }

  if (isSameAsStoredPlaceNodes(stored, nextPlaceNodes)) {
    return
  }

  localStorage.removeItem(localStorageKeys.listFilter)
  localStorage.removeItem(localStorageKeys.listFilterSchedules)
}
